import {useGlp1Modality} from 'surveys/osa_funnel/hooks/useGlp1Modality';
import {PrimerSlide} from './PrimerShell';
import {Glp1PrimerCascadeBody} from './Glp1PrimerCascadeBody';

/** Primer slide B — "What no amount of effort can fix."
 *  Animated cascade (body weight → airway pressure → sleep
 *  interruptions) with Tonight↔Treatment loop. */
export const Glp1PrimerSlideB = () => {
  const modality = useGlp1Modality();
  return (
    <PrimerSlide
      letter="B"
      headline="What no amount of effort can fix."
      subhead="Sleep apnea is physics. So is treating it."
      ctaLabel="Next"
    >
      <Glp1PrimerCascadeBody isActive={true} variant={modality} />
    </PrimerSlide>
  );
};

export default Glp1PrimerSlideB;
